module.exports = __webpack_public_path__ + "img/BR.c3533c13.svg";